<template>
  <div
    class="payable-list-main-wrapper cbg-white-container theme--light v-card border-card input-container"
  >
    <CCol sm="12" class="overflow-auto">
      <p>
        <b
          >Note : Some of the entries shown below with reason "completed_on does
          not exists" might be because of the ongoing OPDs / Home visits /
          Online consultations.</b
        >
      </p>
      <table class="table userlistTable table-width small-table-width">
        <thead>
          <tr class="table-success">
            <th scope="col">Date</th>
            <th scope="col">Payment From</th>
            <th scope="col">Payment to</th>
            <th scope="col">Source</th>
            <th scope="col">Reference ID</th>
            <th scope="col">Payment Status</th>
            <th scope="col">Appointment Date</th>
            <th scope="col">Total</th>
            <th scope="col">Utility Charges</th>
            <th scope="col">Mode of Payment</th>
            <th scope="col">Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.transaction_id">
            <td>{{ entry.date | date }}</td>
            <td>{{ entry.billed_to_metadata | name }}</td>
            <td>{{ entry.billed_by_metadata | name }}</td>
            <td>{{ entry.meta && entry.meta.type }}</td>
            <td>{{ entry.order_id || "-" }}</td>
            <td>{{ entry.status | transactionStatus }}</td>
            <td v-if="entry.meta && entry.meta.type === 'APPOINTMENT'">
              {{ entry.meta.opd_date | date }}
            </td>
            <td v-else>-</td>
            <td>&#8377; {{ entry.total }}</td>
            <td>&#8377; {{ entry.charges || 0 }}</td>
            <td>{{ entry.payment | modeOfPayment }}</td>
            <td>{{ entry | reason }}</td>
          </tr>
        </tbody>
      </table>
    </CCol>
    <pagination
      v-if="!isEmpty"
      class="mx-4 mob-t-center pagination-block"
      :recordPerPage="records_per_page"
      :total="total"
      @changePage="onChangePage"
    />
  </div>
</template>
  <script>
import { mapGetters } from "vuex";
import "@/assets/scss/_accounts.scss";
import dayjs from "dayjs";
import formats from "@/formats.js";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { pickSvg } from "@/views/SVG";
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;

export default {
  components: {
    ...pickSvg("incomeSVG", "searchSVG", "verticalDotsSVG", "crossSVG"),
    Datepicker,
    pagination: () => import("@/views/common/Pagination"),
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },

  filters: {
    date(val) {
      if (!val) {
        return "-";
      }
      return dayjs(val).format(formats.date_time_format);
    },
    name(val) {
      if (!val) {
        return "-";
      }
      return `${val.first_name} ${val.last_name}`;
    },
    modeOfPayment: (value) => {
      const payment = value;
      const modes = payment.map((entry) => entry.mode);
      return modes.join(",");
    },
    currency(val) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(val);
    },
    transactionStatus: (value) => {
      let status = value;
      switch (value) {
        case "void":
          status = "Cancelled";
          break;
        case "draft":
        case "open":
          status = "Pending";
          break;
        case "paid":
          status = "Completed";
          break;
        default:
          status = value;
      }
      return status;
    },
    reason: (value) => {
      let reason = "";
      if (value.status == "paid" && value.paid_amount == 0) {
        reason = `status = paid & paid_amount = 0`;
      } else if (value.status == "paid" && value.payment == []) {
        reason = `status = paid & payment = []`;
      } else if (
        value.status == "paid" &&
        ["APPOINTMENT", "ONLINE_CONSULTATION", "HOME_VISIT"].includes(
          value.meta.type
        ) &&
        !value.meta.completed_on
      ) {
        reason = `status = paid & meta.type = ${value.meta.type} & completed_on does not exists`;
      } else if (
        value.pending_amount == 0 &&
        ["draft", "open"].includes(value.status)
      ) {
        reason = `pending_amount = 0 & status = ${value.status}`;
      }
      return reason;
    },
  },
  data: function () {
    return {
      page: 1,
      total: 0,
      // data
      entries: [],
      // ui
      loading: false,
      isEmpty: false,
      records_per_page: 10,
      currentPage: 1,
    };
  },

  mounted() {
    this.searchEntries();
  },
  methods: {
    onChangePage(page) {
      // const { currentPage } = page;
      // this.offset = (currentPage - 1) * this.limit;
      this.currentPage = page.currentPage;
      this.searchEntries();
    },
    searchEntries() {
      // this.isEmpty = true;
      this.loading = true;
      this.entries = [];
      this.params = {
        page: this.currentPage,
        records_per_page: this.records_per_page,
      };
      this.$http
        .get(
          `${API_URL}/v2/transaction/currupted-transactions?page=${this.params.page}&records_per_page=${this.params.records_per_page}`
        )
        .then(
          (res) => {
            this.loading = false;

            if (res && res.data && res.data.data && res.data.data.list.length) {
              this.entries = res.data.data.list;
              this.isEmpty = false;
              this.currentPage = res.data.data.page;
              this.total = res.data.data.count;
            } else {
              this.entries = [];
              this.currentPage = res.data.data.page;
              this.total = res.data.data.count;
            }
          },
          (err) => {
            this.loading = false;
            this.entries = [];
            console.log(err);
          }
        );
    },
  },
};
</script>